export const percentageMask = (value?: string) => {
  if (!value) return ''

  let v = value.replace(/[^\d.,-]/g, '')

  const isNegative = v.startsWith('-')
  v = v.replace(/-/g, '')

  if (isNegative) {
    v = '-' + v
  }

  v = v.replace(/\./g, ',')

  const hasNumbers = v.replace(/[-,]/g, '')
  if (!hasNumbers) {
    return isNegative ? '-' : ''
  }

  const parts = v.split(',')
  if (parts.length > 2) {
    v = parts.shift()! + ',' + parts.join('')
  }

  if (v.startsWith('-,')) {
    v = '-0,' + v.slice(2)
  } else if (v.startsWith(',')) {
    v = (isNegative ? '-' : '') + '0' + v.slice(1)
  }

  if (v.includes(',')) {
    const [int, dec = ''] = v.split(',')
    v = dec.length > 0 ? `${int},${dec.slice(0, 2)}` : `${int},`
  }

  return v
}
